import { render, staticRenderFns } from "./ErrorLogs.vue?vue&type=template&id=9c0004dc"
import script from "./ErrorLogs.ts?vue&type=script&lang=ts&external"
export * from "./ErrorLogs.ts?vue&type=script&lang=ts&external"
import style0 from "./ErrorLogs.vue?vue&type=style&index=0&id=9c0004dc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports